import React, { useMemo } from 'react';

import FilterButtons from './FilterButtons';
import FilterSelectInput from './FilterSelectInput';

import type { BaseAPIData } from 'types/catalog_types';

export type FilterType = 'options' | 'products';

export type FilterProps = {
  /** string specifying how to display filter */
  filterUI: BaseAPIData['filter_ui'];
  /** Array of possible filters to select */
  filters: string[];
  /** The currently selected filter */
  filterDefault: string;
  handleSelectFilter: (filter: string) => void;
  /** String to use for a11y text describing the filter controls */
  filterType: FilterType;
};

function Filter({ filterUI, filterDefault, filterType, handleSelectFilter, filters }: FilterProps) {
  const realGroups = useMemo(() => filters.filter((group) => group !== 'All'), [filters]);

  const showFilters = useMemo(() => {
    return filterUI !== 'none' && realGroups.length > 0 && filterDefault.length > 0;
  }, [realGroups, filterUI, filterDefault]);

  if (!showFilters) return null;

  // Not entirely sure why we don't use if (filterUi === 'dropdown'), but not going to mess with that since it's working
  if (filterUI === '') {
    return (
      <FilterButtons
        filters={filters}
        filter={filterDefault}
        handleSelectFilter={handleSelectFilter}
      />
    );
  }

  return (
    <FilterSelectInput
      filters={filters}
      filter={filterDefault}
      handleSelectFilter={handleSelectFilter}
      filterType={filterType}
    />
  );
}

export default Filter;
